'use client'

import Script from 'next/script'

export const OneTrustScript = () => {
  // Supress React 19/Next 16 errors related to executing `<script />` on the client
  // The script tag will still be rendered on the server & will persist once served to the client if rendered in the `head`.
  if (typeof window !== 'undefined') return null

  return (
    <Script
      id='onetrust-stub-script'
      src='https://cdn.cookielaw.org/scripttemplates/otSDKStub.js'
      strategy='beforeInteractive' // Scripts that alter the UI are before interactive
      data-domain-script='5f6fbb5a-ed5e-4087-8c32-2c813aa00c2a'
    />
  )
}
